<div class="versions">
  <span class="version">Payment v{{ version }}</span>
  <span class="version">Pathé Payment API {{ versionBo$ | async }}</span>
</div>
<a (click)="refresh()">
  <img src="assets/svg/icons/Refresh.svg" />
</a>
<pui-button (click)="deconnexion()">{{ 'pages.parametres.deconnexion' | translate }}</pui-button>
